export class CellEditedInfoDto {
  originalValue: any;
  newValue: any;

  constructor(init: Readonly<CellEditedInfoDto>) {
    Object.assign(this, init);
  }
}
